import React, { createContext } from 'react'

const AccordionContext = createContext<{
  readonly toggle?: React.EventHandler<React.SyntheticEvent>
}>({})

export { AccordionContext }